/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc
 */

export const generateIndustryUseCaseRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.IndustryUseCaseRpc',
  rpcName: 'generateIndustryUseCase',
  auth: 'app',
  fingerprint: 'YC7ZM_KfCIWXYPIZdpEL1SzqsfS-LNDe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};